import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Reveal, SectionHeading } from "./shared";
import { FAQS } from "./content";

export default function Faq() {
    return (
        <section id="faq" className="relative py-24 sm:py-32">
            <div className="mx-auto max-w-4xl px-5 sm:px-8">
                <SectionHeading
                    eyebrow="Good To Know"
                    title="Frequently asked questions"
                    align="center"
                />
                <Reveal delay={0.15} className="mt-12">
                    <Accordion type="single" collapsible className="glass-card rounded-3xl px-6 sm:px-8">
                        {FAQS.map((f, i) => (
                            <AccordionItem
                                key={f.q}
                                value={`item-${i}`}
                                className="border-gold/15 last:border-0"
                                data-testid={`faq-item-${i}`}
                            >
                                <AccordionTrigger className="py-6 font-serif text-lg font-semibold text-cream hover:text-gold hover:no-underline sm:text-xl">
                                    {f.q}
                                </AccordionTrigger>
                                <AccordionContent className="pb-6 text-sm leading-relaxed text-mist sm:text-base">
                                    {f.a}
                                </AccordionContent>
                            </AccordionItem>
                        ))}
                    </Accordion>
                </Reveal>
            </div>
        </section>
    );
}
